module.exports = __webpack_public_path__ + "img/AirplanemodeInactiveOutlined.e4f9e453.svg";